function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadideaRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.27 382.46 442.27 333.14 419.51 333.14 419.51 287.41 416.3 287.41 416.3 313.62 407.55 313.62 407.55 306.37 391.79 306.37 391.79 281.27 388.88 281.27 388.88 250.6 386.54 250.6 386.54 280.72 381 280.72 381 325.33 370.49 325.33 370.49 280.72 351.52 280.72 351.52 318.45 331.61 318.45 331.61 272.72 328.4 272.72 328.4 298.93 319.65 298.93 319.65 291.68 303.89 291.68 303.89 266.58 300.98 266.58 300.98 235.91 298.64 235.91 298.64 266.02 293.1 266.02 293.1 310.64 282.59 310.64 282.59 266.02 263.63 266.02 263.63 309.18 250.84 309.18 250.84 284.08 247.92 284.08 247.92 253.41 245.58 253.41 245.58 283.53 240.04 283.53 240.04 328.14 229.53 328.14 229.53 283.53 210.57 283.53 210.57 328.14 201.23 328.14 201.23 333.14 184.87 333.14 184.87 287.41 181.66 287.41 181.66 313.62 172.91 313.62 172.91 306.37 157.15 306.37 157.15 281.27 154.23 281.27 154.23 250.6 151.9 250.6 151.9 280.72 146.81 280.72 146.81 278.2 127.84 278.2 127.84 280.72 117.34 280.72 117.34 278.2 111.8 278.2 111.8 248.09 109.46 248.09 109.46 278.76 106.54 278.76 106.54 303.86 90.79 303.86 90.79 311.11 82.03 311.11 82.03 284.9 78.82 284.9 78.82 330.63 56.06 330.63 56.06 382.46 442.27 382.46",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.32,
    cy: 127.32,
    r: 27.79,
    transform: "translate(-49.52 135.1) rotate(-45)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.9,127a4.83,4.83,0,0,0-6.21-4.63,10.21,10.21,0,0,0-10.12-11.71,9.77,9.77,0,0,0-1.89.18,8.94,8.94,0,0,0-16.58,4.52H89a8.24,8.24,0,1,0,0,16.48h30.25A4.82,4.82,0,0,0,123.9,127Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.19,193.93a4.8,4.8,0,0,0-6.21-4.62,10.46,10.46,0,0,0,.1-1.49,10.22,10.22,0,0,0-10.23-10.22,10.6,10.6,0,0,0-1.88.17,8.94,8.94,0,0,0-16.58,4.52h-.15a8.24,8.24,0,0,0,0,16.48H423.5A4.84,4.84,0,0,0,428.19,193.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.13,120.57a7.64,7.64,0,0,1,7.64-7.64,7.54,7.54,0,0,1,2.19.33,16.56,16.56,0,0,1-.17-2.35A16.17,16.17,0,0,1,314,95a14.15,14.15,0,0,1,26.23,7.15h.23a13,13,0,0,1,0,26.08H292.55A7.64,7.64,0,0,1,285.13,120.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.89,203.79a9.19,9.19,0,0,1,11.84-8.8,20.38,20.38,0,0,1-.2-2.83A19.47,19.47,0,0,1,175,172.69a19.25,19.25,0,0,1,3.59.33,17,17,0,0,1,31.57,8.61l.28,0a15.69,15.69,0,0,1,0,31.38H152.83A9.19,9.19,0,0,1,143.89,203.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51,141.48a3,3,0,0,0-3-3,3,3,0,0,0-.86.12,7,7,0,0,0,.07-.92,6.36,6.36,0,0,0-6.36-6.36,6.56,6.56,0,0,0-1.18.11,5.55,5.55,0,0,0-10.3,2.81h-.1a5.12,5.12,0,0,0,0,10.24h18.81A3,3,0,0,0,184.51,141.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.14,232.68A3,3,0,0,1,79,229.8a7,7,0,0,1-.07-.92,6.36,6.36,0,0,1,6.36-6.36,6.56,6.56,0,0,1,1.18.11,5.55,5.55,0,0,1,10.3,2.81h.09a5.13,5.13,0,1,1,0,10.25H78.06A3,3,0,0,1,75.14,232.68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,242.48a3,3,0,0,1,3.86-2.88,7,7,0,0,1-.07-.92,6.36,6.36,0,0,1,6.36-6.36,6.56,6.56,0,0,1,1.18.11,5.55,5.55,0,0,1,10.3,2.81h.09a5.13,5.13,0,1,1,0,10.25h-18.8A3,3,0,0,1,356.63,242.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.65 366.2 408.43 328.94 403.23 339.72 353.27 265.62 270.52 239.18 242.64 178.82 115.87 91.52 116.21 118.04 95.81 130.32 208.24 196.05 241.35 256.84 338.33 287.8 388.53 351.83 377.72 355.03 413.65 366.2",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.55,392.3s4.75-10.36-.68-20.58-7-12.62-3.54-14.72,5.05,8.18,5.05,8.18a23.1,23.1,0,0,0,.5-14.46c-2.4-7.39-3.91-19.43-.62-20.72s.62,15,3.48,20.58a48.19,48.19,0,0,0,2.79-12.13c.39-5.94-.22-15.42,2.37-17.85s4.26-.75,1.71,12.36a137.07,137.07,0,0,0-2.53,23.75s5.63-17.19,9.42-17.69,3.78,5.06.54,9.89-9.49,13.48-10.51,17.93c0,0,6.19-12.94,11.75-9s-4.84,11.77-9.48,14.6S375.94,393,375.94,393Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.55,392.3s4.75-10.36-.68-20.58-7-12.62-3.54-14.72,5.05,8.18,5.05,8.18a23.1,23.1,0,0,0,.5-14.46c-2.4-7.39-3.91-19.43-.62-20.72s.62,15,3.48,20.58a48.19,48.19,0,0,0,2.79-12.13c.39-5.94-.22-15.42,2.37-17.85s4.26-.75,1.71,12.36a137.07,137.07,0,0,0-2.53,23.75s5.63-17.19,9.42-17.69,3.78,5.06.54,9.89-9.49,13.48-10.51,17.93c0,0,6.19-12.94,11.75-9s-4.84,11.77-9.48,14.6S375.94,393,375.94,393Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.3,396.55s-4.63-10.43.92-20.57,7.15-12.52,3.72-14.66-5.15,8.1-5.15,8.1a23.07,23.07,0,0,1-.33-14.46c2.5-7.36,4.15-19.38.88-20.72s-.81,15-3.73,20.53A48.29,48.29,0,0,1,371,342.6c-.32-5.94.41-15.41-2.16-17.88s-4.25-.81-1.85,12.33a137.07,137.07,0,0,1,2.24,23.78S363.76,343.56,360,343s-3.84,5-.66,9.88,9.32,13.62,10.29,18.08c0,0-6-13-11.64-9.14s4.7,11.84,9.3,14.74,7.62,20.63,7.62,20.63Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.96 389.11 394.18 389.11 391.08 416.46 359.06 416.46 355.96 389.11",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.4,197.07c6.32,5.17,14.41,12.62,21.16,17l.14.09c.06,0,0,0,0,0s.16.17.72.14c5.06-1.08,9.91-5.58,14.15-9a2.56,2.56,0,0,1,3.92,3.24,45.62,45.62,0,0,1-9.07,10.5,19.11,19.11,0,0,1-7.13,3.92,9.94,9.94,0,0,1-6.77-.52l-1.09-.56c-8.42-4.69-15.64-10.78-22.83-17.08-4.86-4.64,1.56-11.94,6.78-7.71Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.7,212.2a46.76,46.76,0,0,1,5.78,3.06c4.76,2.82,10.3,6.46,10.3,6.46l4.54-9.69c-8.69-8.92-21.73-15.94-21.73-15.94s-.51,3-.74,6.35C305.55,206.62,305.68,211.46,307.7,212.2Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.13 221.56 328.32 210.33 330.92 214.06 325.6 223.38 323.13 221.56",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.13 221.56 328.32 210.33 330.92 214.06 325.6 223.38 323.13 221.56",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.7,210.05a48.24,48.24,0,0,1,5.78,2.65,22.51,22.51,0,0,0-6.94-11.6,7.09,7.09,0,0,0-.69.49C305.55,205.21,305.68,209.41,307.7,210.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,249.22s.48,8.12,4.44,22.34a223.08,223.08,0,0,0,9.05,25.87q3,7.14,6.84,15.12c1.18,2.42,2.43,4.88,3.75,7.4,1.52,43.08,25.69,86.87,25.69,86.87,1.34.69,6-.07,6-1.43-3.58-5.68-10.62-60.87-15.16-87.05-.28-3.56-.69-7.37-1.19-11.31-1.33-10.56-3.29-22.06-5.2-32.17-3-15.92-5.86-28.4-5.86-28.4l-8,.77Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.48,308.85h0q1,6.93,2.49,14.86c-8.64,28.81,9.12,85,9.12,85,3,.59,5.66.2,7-.8-3.35-16.94-.94-61,1.66-87.31.23-2.38.52-5,.84-7.82.54-4.74,1.18-10,1.86-15.38,1.14-9.05,2.43-18.58,3.59-27,1.42-10.21,2.66-18.84,3.29-23.18.28-1.91.43-3,.43-3l-24.93,2.7s-6.34,7.11-7.3,29.31A181.41,181.41,0,0,0,272.48,308.85Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.48,308.85h0a77.34,77.34,0,0,0,21.12,4c.54-4.74,1.18-10,1.86-15.38q3,7.14,6.84,15.12A51.86,51.86,0,0,0,321.38,307c-1.33-10.56-3.29-22.06-5.2-32.17a31.24,31.24,0,0,0-8.47-3.41,37.62,37.62,0,0,0-8.65-1,65.87,65.87,0,0,0-12.64,1.15,79.49,79.49,0,0,0-15.87,4.69A181.41,181.41,0,0,0,272.48,308.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.34,196.83s1.11,4.12,2.31,11c.31,1.7.62,3.59.91,5.61.21,1.47.41,3,.61,4.62.22,1.83.43,3.76.62,5.75a193.86,193.86,0,0,1,.83,23h32.83s5.18-38.4-3.37-50.78C307.08,196.11,290.25,188.18,272.34,196.83Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.65,207.87c.31,1.7.62,3.59.91,5.61.21,1.47.41,3,.61,4.62a26.42,26.42,0,0,0-.1-15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.32,190.53c-10.3,0-11.59,8.47-11.59,8.47l4.81-2.07,14.15,9.46,3.47-9.55,4.36.81S298.26,190.54,289.32,190.53Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.32,190.53c-10.3,0-11.59,8.47-11.59,8.47l4.81-2.07,14.15,9.46,3.47-9.55,4.36.81S298.26,190.54,289.32,190.53Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.94,195.22l13.35,10c0-.08,2.07-10,2.07-10-3.15-.69-4.44-2.22-4.78-4.06a10.13,10.13,0,0,1,.46-4.47l-7.39-5.85-2-1.57C285.58,183.83,286.45,192.18,282.94,195.22Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.59,184.21c.28,2.87,3.8,5.86,7,6.95a10.13,10.13,0,0,1,.46-4.47l-7.39-5.85A12.69,12.69,0,0,0,286.59,184.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,169.12l-.7-.25,2.27-6.27a7.28,7.28,0,0,0-1.05-.89l.43-.61a6.09,6.09,0,0,1,1.35,1.23l.1.15Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,176.36s6.52-13.27-6.59-21.05-22.6,8.47-21.28,16.62c.56,3.51,1.88,7.79,5.26,9.9,1.36.84,1.46-3,1.46-3S298.59,183.34,307,176.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,167.54c-1.17,8.07-1.83,11.45,1.26,16.56,4.64,7.69,14.56,7.85,18.06.42,3.14-6.7,4.52-18.76-2.44-23.94A10.44,10.44,0,0,0,285.33,167.54Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.72,164.29c-6,4,.44,13.11-8,9.82s-.83-14.24,5.21-15.25S293.72,164.29,293.72,164.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,175.62a19.92,19.92,0,0,0,1.48,4.89,2.71,2.71,0,0,1-2.38-.15Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,168a.38.38,0,0,0-.29.08,2.94,2.94,0,0,1-2.72.59.37.37,0,0,0-.48.25.43.43,0,0,0,.27.51,3.64,3.64,0,0,0,3.44-.71.4.4,0,0,0,0-.56A.43.43,0,0,0,300,168Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.56,169a.41.41,0,0,0-.29,0,.4.4,0,0,0-.16.54,4.18,4.18,0,0,0,2.86,2.36.37.37,0,0,0,.43-.34.45.45,0,0,0-.35-.46,3.32,3.32,0,0,1-2.25-1.89A.43.43,0,0,0,305.56,169Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.27,160.84s-3.68,6.21-9.18,7.69-5.88-1.22-5.88-1.22.41-7.9,7.66-9.54c0,0,1.07-2.34,7.38-1.81s13.59,5.73,11.17,13.21a10.3,10.3,0,0,0-4.6-1.77,11,11,0,0,0-4.35-6.36,11,11,0,0,1,2.59,6S300.64,162.46,297.27,160.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.68,173.45l1.64-.06S299.29,174.44,298.68,173.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.68,173.45a2.5,2.5,0,0,1-2.89.14s1.43,1.18,2.34,1a1.76,1.76,0,0,0,1.28-.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.34,174.48l1.63-.06S305.94,175.47,305.34,174.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.34,174.48s-.44,1-2.18.11c0,0,.71,1.21,1.62,1.07a1.76,1.76,0,0,0,1.28-.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.17,183.61a.25.25,0,0,1-.25-.2s-.44-2.13-3.48-3.46a.25.25,0,0,1-.13-.33.26.26,0,0,1,.33-.13c3.3,1.45,3.76,3.73,3.77,3.83a.25.25,0,0,1-.2.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.13,160c-2.21,0-3.89-.9-3.89-2.09s1.68-2.1,3.89-2.1,3.89.9,3.89,2.1S299.35,160,297.13,160Zm0-3.44c-1.85,0-3.14.71-3.14,1.35s1.29,1.34,3.14,1.34,3.14-.71,3.14-1.34S299,156.58,297.13,156.58Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,162.33a5.81,5.81,0,0,1-2.8-.87c-1.92-1.1-2.92-2.72-2.32-3.76h0c.6-1,2.49-1,4.41.13s2.92,2.73,2.32,3.76A1.73,1.73,0,0,1,308,162.33Zm-4.47-4.25c-.32.55.44,1.81,2,2.73s3.07,1,3.39.41-.44-1.81-2-2.74-3.07-.95-3.39-.4Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.75,158.55a1.78,1.78,0,0,0-1.08-.65,1,1,0,0,0-.77.3l-.51-.55a1.74,1.74,0,0,1,1.34-.5,2.62,2.62,0,0,1,1.61.93Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.37,172.61l-.7-.26,4.92-13.72.08-.07a8.6,8.6,0,0,1,2.88-1l.14.74a8.61,8.61,0,0,0-2.47.79Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.1,174.6a5.56,5.56,0,0,0,2.26,3.92c1.6,1.07,3.06-.69,3.16-2.91.09-2-.63-5-2.51-5.11S281.82,172.52,282.1,174.6Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.47,416.1h1.39l.39-1.72,4.59,2.08H301.5s1.85-1.87-3.7-3.35a4.35,4.35,0,0,1-.79-.3c-2.95-1.39-7.17-6.07-7.17-6.07h-6.39a8.47,8.47,0,0,0-.52.92C282.23,409.06,281,412,283.47,416.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.93,407.66v0c.84-.94,4.68,3.19,7.5,4.6,2.51,1.25,5.33,1.8,6.58.53-2.95-1.39-7.61-7.45-7.61-7.45h-5.14S283.23,407.06,282.93,407.66Z",
    style: {
      fill: "#ffc2bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,416.1h1.39l.38-1.72,4.6,2.08H350s1.86-1.87-3.69-3.35a4.08,4.08,0,0,1-.79-.3c-3-1.39-7.17-6.07-7.17-6.07H332a8.47,8.47,0,0,0-.52.92C330.77,409.06,329.56,412,332,416.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.47,407.66v0c.84-.94,4.68,3.19,7.49,4.6,2.52,1.25,5.34,1.8,6.59.53-3-1.39-7.61-7.45-7.61-7.45H332.8S331.77,407.06,331.47,407.66Z",
    style: {
      fill: "#ffc2bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.77,244.25h-33.1l-.89,4.26s-12.16,16.83-6,58.8c0,0,26.63,3.07,51.71-2.31,0,0-5.63-43.11-11.52-57.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.54 247.91 276.43 247.91 277.1 244.75 287.54 244.75 287.54 247.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.71 244.75 311.04 244.75 311.32 247.91 307.71 247.91 307.71 244.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.62,
    y: 244.75,
    width: 17.99,
    height: 3.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.54 247.91 276.43 247.91 277.1 244.75 287.54 244.75 287.54 247.91",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.71 244.75 311.04 244.75 311.32 247.91 307.71 247.91 307.71 244.75",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.62,
    y: 244.75,
    width: 17.99,
    height: 3.17,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.07,
    y: 244.51,
    width: 6.08,
    height: 3.65,
    rx: 0.54,
    transform: "translate(598.21 492.66) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.23,199.84l.13,2.53a3,3,0,0,1-1.1,2.46l-3.49,2.78a5.49,5.49,0,0,1-4.94,1l-1.06-.3c-.51-4.18,2-9.08,2-9.08l.56-1.47a2.45,2.45,0,0,1,3.15-1.5l2.94,1.09A2.81,2.81,0,0,1,354.23,199.84Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.73,208.32c-4.41,4.75-9.64,10.44-13.93,15.3l.52-.83c.1-.25.06-.39,0-.32.12,2.86,2,5.58,3.55,8.23,2.28,3.67,5,7.32,7.57,10.79a2.56,2.56,0,0,1-3.62,3.55c-1.89-1.47-3.59-3-5.31-4.62a51,51,0,0,1-9.21-11.27c-1.78-3.16-3.27-7.75-.83-11.25a121.48,121.48,0,0,1,14-16.84c4.93-4.45,11.71,2.33,7.26,7.26Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.34,196.82s-7.45,3.86-17.71,18.18l8.15,6.65,12.43-10.45a17.5,17.5,0,0,0,1.22-9.32C275.54,197.18,272.34,196.82,272.34,196.82Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.94 221.17 253.86 213.21 252.32 217.62 261.92 223.38 263.94 221.17",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.94 221.17 253.86 213.21 252.32 217.62 261.92 223.38 263.94 221.17",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.41,249.65l.2-2.52a3,3,0,0,0-1.05-2.49l-3.41-2.86a5.51,5.51,0,0,0-4.92-1.1l-1.07.28c-.61,4.16,1.79,9.12,1.79,9.12l.53,1.49a2.46,2.46,0,0,0,3.12,1.57l3-1A2.81,2.81,0,0,0,277.41,249.65Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.53,155.88s-2.68-11.12-12.88-9.14-3.86,18.87-6,25.19-2.56,16.2,6,18a7.26,7.26,0,0,1-1.75-8.44,6.12,6.12,0,0,0,.92,4.46,5.76,5.76,0,0,1,.83-6.28c2.6-2.92,7.78-13.79,8.29-17.19S287.53,155.88,287.53,155.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.18,158h1a1.29,1.29,0,0,1,1.29,1.29v53.05a0,0,0,0,1,0,0h-3.56a0,0,0,0,1,0,0V159.33a1.29,1.29,0,0,1,1.29-1.29Z",
    transform: "translate(718.31 307.41) rotate(169.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.16,
    cy: 147.5,
    rx: 21.1,
    ry: 22.27,
    transform: "translate(-20.53 60.95) rotate(-10.03)",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.16,
    cy: 147.5,
    rx: 21.1,
    ry: 22.27,
    transform: "translate(-20.53 60.95) rotate(-10.03)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.13,
    cy: 147.15,
    rx: 21.1,
    ry: 22.27,
    transform: "translate(-20.44 61.29) rotate(-10.03)",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.13,
    cy: 147.15,
    rx: 21.1,
    ry: 22.27,
    transform: "translate(-20.44 61.29) rotate(-10.03)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.51 158.49 337.2 147.49 326.2 139.8 327.79 137.53 338.79 145.22 346.48 134.22 348.75 135.81 341.06 146.81 352.06 154.5 350.47 156.77 339.47 149.08 331.78 160.08 329.51 158.49",
    style: {
      fill: "#6640FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.59,303v10.47l-11.26-2.24-2.73,1.68,2.73,4.94-5.1-3.95-5.34.79-2.17,16.26-5.93-5-9.86,8,2.64,4.87-5.8-6.13-12.12,11.43V333.8l-7.32,6.8L112,360l14,18.92,28.48,1,35.61-14.08s4.35-26.7,4.35-27.29v-20l-9.89-10.38Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.59,303v10.47l-11.26-2.24-2.73,1.68,2.73,4.94-5.1-3.95-5.34.79-2.17,16.26-5.93-5-9.86,8,2.64,4.87-5.8-6.13-12.12,11.43V333.8l-7.32,6.8L112,360l14,18.92,28.48,1,35.61-14.08s4.35-26.7,4.35-27.29v-20l-9.89-10.38Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,412c6.35,2.71,15.21-3.81,19.78-14.56s3.15-21.64-3.2-24.35-15.21,3.82-19.79,14.56S228.67,409.29,235,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.49,411.14a6.12,6.12,0,0,1-4.54.13c-6.23-2.65-5.64-18.06,1.33-34.41s17.67-27.46,23.9-24.8a6.09,6.09,0,0,1,3,3.36,4.91,4.91,0,0,1,2.2.35,5.88,5.88,0,0,1,3,3.37,4.79,4.79,0,0,1,2.27.34,5.77,5.77,0,0,1,2.93,3.41,4.61,4.61,0,0,1,2.32.3,5.6,5.6,0,0,1,2.88,3.46,4.37,4.37,0,0,1,2.37.25c5.18,2.21,4.69,15-1.1,28.61s-14.69,22.83-19.87,20.62a4.53,4.53,0,0,1-1.83-1.53,5.64,5.64,0,0,1-4.49.32,4.66,4.66,0,0,1-1.82-1.47,5.73,5.73,0,0,1-4.49.25,4.7,4.7,0,0,1-1.81-1.4,6,6,0,0,1-4.5.19A4.93,4.93,0,0,1,210.49,411.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.49,411.14a6.12,6.12,0,0,1-4.54.13c-6.23-2.65-5.64-18.06,1.33-34.41s17.67-27.46,23.9-24.8a6.09,6.09,0,0,1,3,3.36,4.91,4.91,0,0,1,2.2.35,5.88,5.88,0,0,1,3,3.37,4.79,4.79,0,0,1,2.27.34,5.77,5.77,0,0,1,2.93,3.41,4.61,4.61,0,0,1,2.32.3,5.6,5.6,0,0,1,2.88,3.46,4.37,4.37,0,0,1,2.37.25c5.18,2.21,4.69,15-1.1,28.61s-14.69,22.83-19.87,20.62a4.53,4.53,0,0,1-1.83-1.53,5.64,5.64,0,0,1-4.49.32,4.66,4.66,0,0,1-1.82-1.47,5.73,5.73,0,0,1-4.49.25,4.7,4.7,0,0,1-1.81-1.4,6,6,0,0,1-4.5.19A4.93,4.93,0,0,1,210.49,411.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,411.52a56.81,56.81,0,0,0,48.58-1.87,9.46,9.46,0,0,1,8.89,0,3,3,0,0,0,.4.2c6.33,2.69,17.2-8.58,24.27-25.19s7.68-32.25,1.35-34.95a3.66,3.66,0,0,0-.43-.15,9.32,9.32,0,0,1-6.09-6.35,56.86,56.86,0,0,0-34.52-37.31,55.65,55.65,0,0,0-10.83-2.9L173,304.52l10.74,8.3L182,314.21l1.78,3.36-3.55-2.17-4,2.17,7.52,16.23-15.08,2.56-1.93,3,4.66,6.77-6.24-5.5-5.74,6.25-1.58,19.78-5.13-6.33-10.1-12.46h-8.31l-2,7.51v-7.71l-6.73-1.54-9.18,13.25-1.89,2.73,1.4-6.19v0l3.15-14-1.46.38-3.09.81L116.9,336l-1.47-.38A56.94,56.94,0,0,0,145,411.52Z",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.61,408.64c5.64,2.48,15.87-8.37,22.84-24.24s8.05-30.74,2.41-33.22S212,359.55,205,375.42,197,406.16,202.61,408.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.27,393.07a.39.39,0,0,0,.25-.08c13.08-9.73,40-2.66,40.32-2.59a.4.4,0,0,0,.5-.29.41.41,0,0,0-.29-.5c-1.09-.29-26.14-6.85-39.85,1.92l3.65-8.57a.42.42,0,0,0-.08-.44l-5.45-5.66,15.47-.68a.4.4,0,0,0,.36-.25.42.42,0,0,0-.07-.43l-10.3-11.7,14-1.32a.42.42,0,0,0,.34-.25.38.38,0,0,0-.06-.41l-8.68-10.95h7.91a.43.43,0,0,0,.38-.25l3.81-8.95c1.78,4.21,10,21.66,26.82,28.82a.42.42,0,0,0,.54-.22.4.4,0,0,0-.22-.53c-18.75-8-26.67-29.07-26.75-29.28a.39.39,0,0,0-.37-.27.42.42,0,0,0-.39.25L191,350.05h-8.49a.42.42,0,0,0-.37.23.42.42,0,0,0,0,.43l8.74,11-14,1.34a.39.39,0,0,0-.34.25.4.4,0,0,0,.07.42L186.9,375.4l-15.52.68a.41.41,0,0,0-.36.26.4.4,0,0,0,.09.43l5.88,6.12-4.09,9.61a.41.41,0,0,0,.37.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,411.52a56.81,56.81,0,0,0,48.58-1.87,9.46,9.46,0,0,1,8.89,0,3,3,0,0,0,.4.2c6.33,2.69,17.2-8.58,24.27-25.19s7.68-32.25,1.35-34.95a3.66,3.66,0,0,0-.43-.15,9.32,9.32,0,0,1-6.09-6.35,56.86,56.86,0,0,0-34.52-37.31,55.65,55.65,0,0,0-10.83-2.9L173,304.52l10.74,8.3L182,314.21l1.78,3.36-3.55-2.17-4,2.17,7.52,16.23-15.08,2.56-1.93,3,4.66,6.77-6.24-5.5-5.74,6.25-1.58,19.78-5.13-6.33-10.1-12.46h-8.31l-2,7.51v-7.71l-6.73-1.54-9.18,13.25-1.89,2.73,1.4-6.19v0l3.15-14-1.46.38-3.09.81L116.9,336l-1.47-.38A56.94,56.94,0,0,0,145,411.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,346.1l-9.18,13.25c1.25,6.16,4.53,11.07,9.56,13.28,8.64,3.8,19.67-1.61,26.74-12.33l-10.1-12.46h-8.31l-2,7.51v-7.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.93,355.87l3.15-14-1.46.38A36.6,36.6,0,0,0,115.93,355.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,386.55c1.45,2.65,5.74,3.11,9.57,1s5.76-5.95,4.31-8.61-5.74-3.11-9.57-1S133.51,383.89,135,386.55Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.77,358.61a85.16,85.16,0,0,1-2,14.52c-.58,2.35-1.13,4.7-1.93,7-.36,1.15-.8,2.27-1.2,3.4s-.9,2.23-1.4,3.32c-1,2.21-2,4.38-3.22,6.48s-2.45,4.16-3.75,6.2a66.45,66.45,0,0,1-9.36,11.22,31.28,31.28,0,0,0,6.08-4.36,48.58,48.58,0,0,0,5.17-5.46,56.45,56.45,0,0,0,4.33-6.17A69.59,69.59,0,0,0,233,388a53.41,53.41,0,0,0,4.08-14.5,49.62,49.62,0,0,0,.47-7.5A38.47,38.47,0,0,0,236.77,358.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.87,361.43a102.64,102.64,0,0,1-2.35,14.5c-.6,2.36-1.17,4.71-1.9,7l-1.09,3.47c-.41,1.14-.78,2.31-1.23,3.42s-.83,2.25-1.36,3.32l-.74,1.64-.83,1.59c-.51,1.09-1.15,2.11-1.74,3.15-.31.52-.65,1-1,1.52s-.64,1-1,1.52a56.83,56.83,0,0,1-4.46,5.73,51,51,0,0,1-5.19,5.21,30.3,30.3,0,0,0,6.22-4.16,41.38,41.38,0,0,0,5.3-5.37,46.28,46.28,0,0,0,7.57-13.1,71.09,71.09,0,0,0,3.7-14.55A49.11,49.11,0,0,0,242.87,361.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248,365.5A59.12,59.12,0,0,1,246.14,379a89.27,89.27,0,0,1-4.25,12.83,65,65,0,0,1-2.85,6.1c-1,2-2.22,3.9-3.4,5.81a55.82,55.82,0,0,1-8.76,10.41,26.81,26.81,0,0,0,5.78-3.93,41.86,41.86,0,0,0,4.87-5.09c.73-.92,1.47-1.85,2.11-2.84l1-1.47.91-1.51a56.4,56.4,0,0,0,6.89-19.87A35,35,0,0,0,248,365.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.51,370.84a75.77,75.77,0,0,1-2.38,12.3A89.82,89.82,0,0,1,247,394.8a81.28,81.28,0,0,1-5.73,10.94,43,43,0,0,1-8,9.54,20.21,20.21,0,0,0,5.41-3.47,35.39,35.39,0,0,0,4.46-4.7A48.89,48.89,0,0,0,249.71,396a54.71,54.71,0,0,0,3.68-12.35A36.7,36.7,0,0,0,253.51,370.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "98.96 416.09 111.95 416.09 105.45 412.6 97.64 416.09",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.76 416.09 134.48 414.35 140.46 414.72 138.78 416.24 128.76 416.09",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.42 410.72 125.59 409.02 130.34 409.87 128.76 412.6 116.42 410.72",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.81 412.6 88.41 410.81 95.65 411.6 92.1 414.35 81.81 412.6",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.06 416.46 198.99 416.46 196.91 414.16 192.06 414.16 192.06 416.46",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "98.96 416.09 111.95 416.09 105.45 412.6 97.64 416.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.76 416.09 134.48 414.35 140.46 414.72 138.78 416.24 128.76 416.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.42 410.72 125.59 409.02 130.34 409.87 128.76 412.6 116.42 410.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.81 412.6 88.41 410.81 95.65 411.6 92.1 414.35 81.81 412.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.06 416.46 198.99 416.46 196.91 414.16 192.06 414.16 192.06 416.46",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "102.61 204.56 87.12 188.6 104.84 201.06 108.05 196.05 95.7 183.32 109.83 193.26 120.44 176.68 181.05 182.19 183.98 185.96 196.56 173.75 186.07 188.66 190.04 193.77 201.83 182.33 192 196.31 219.11 231.26 203.83 251.28 215.94 263.76 201.86 253.86 197.81 259.18 207.37 269.03 196.25 261.22 183.14 278.4 153.92 275.83 159.83 296.02 147.01 295.81 161.39 335.07 133.16 288.28 146.26 289.25 139.94 274.6 123.34 273.14 111.03 258.64 96.87 272.39 108.57 255.74 104.66 251.13 91.59 263.81 102.39 248.46 86.5 229.74 102.61 204.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.61 204.56 87.12 188.6 104.84 201.06 108.05 196.05 95.7 183.32 109.83 193.26 120.44 176.68 181.05 182.19 183.98 185.96 196.56 173.75 186.07 188.66 190.04 193.77 201.83 182.33 192 196.31 219.11 231.26 203.83 251.28 215.94 263.76 201.86 253.86 197.81 259.18 207.37 269.03 196.25 261.22 183.14 278.4 153.92 275.83 159.83 296.02 147.01 295.81 161.39 335.07 133.16 288.28 146.26 289.25 139.94 274.6 123.34 273.14 111.03 258.64 96.87 272.39 108.57 255.74 104.66 251.13 91.59 263.81 102.39 248.46 86.5 229.74 102.61 204.56",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.16,242.67c-4.83,3.09-6.76,4-10.64,14,0,0-2.22,2-3.29-2.31s3.85-11.52,4.27-14.53-11-2.9-13.52-4-3.5-5.56.2-7c0,0-6.36-3.75,1.47-7.39,0,0-4.22-4.7,1.84-7.07,0,0-1.46-3.88,5.55-5.39,5.2-1.13,22.84,4.32,25.28,7.9l-3.58,19C162.32,239.94,159.48,240.53,156.16,242.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.69,
    y: 216.17,
    width: 11.5,
    height: 24.86,
    rx: 1.61,
    transform: "translate(292.55 486.27) rotate(-168.65)",
    style: {
      fill: "#6640FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.69,
    y: 216.17,
    width: 11.5,
    height: 24.86,
    rx: 1.61,
    transform: "translate(292.55 486.27) rotate(-168.65)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,218.73a1.44,1.44,0,1,1,1.13,1.7A1.43,1.43,0,0,1,171,218.73Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadideaRafiki);
export default __webpack_public_path__ + "static/media/Bad idea-rafiki.7085fdabb2ac03920c2c629c4d10e8f1.svg";
export { ForwardRef as ReactComponent };